<template>
  <div>
    <el-row :gutter="10">
      <el-col :lg="{ span: 24 }" :xl="{ span: 20 }">
        <el-descriptions
          border
          size="small"
          class="pdCostsOrder-detail-main-form"
          labelClassName="form-label"
        >
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_orderNo') || '订单编号'"
          >
            {{ formData.orderNo || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_orderNo') || '客户订单编号'"
          >
            {{ formData.custOrderNo || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
          >
            {{ formData.custName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
          >
            {{ formData.endCustName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_brand') || '客户品牌'"
          >
            {{ formData.brandName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_orderType') || '订单类型'"
          >
            {{ formData.v_orderType || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_salesPersonCode') || '业务人员'"
          >
            {{ formData.salesPersonName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_bizPersonCode') || '跟单人员'"
          >
            {{ formData.bizPersonName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_orderExecuteType') || '执行方式'"
          >
            {{ formData.v_orderExecuteType || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_quotedMethod') || '报价方式'"
          >
            {{ formData.v_quotedMethod || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="
              $l('INDEX.order_form_label_factoryPaymentTerms') || '工厂付款条件'
            "
          >
            {{ formData.v_factoryPaymentTerms || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.order_form_label_deliveryDay') || '交货日期'"
          >
            {{ formData.deliveryDay || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="
              $l('INDEX.form_label_production_order_remark') || '订单备注说明'
            "
          >
            {{ formData.orderRemark || '' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>

    <div style="display: inline-flex;" class="mt-3 mb-2">
      <div class="side-frame-success">
        <span style="font-size: 14px; color: #606266">
          {{ $l('form_label_pdcosts_order_status') || '核价状态' }}：{{
            formData.v_pdcostsOrderStatus
          }}
        </span>
      </div>
      <div style="display: flex;align-items: center;">
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
      <div v-if="!disabled">
        <el-divider direction="vertical"></el-divider>
        <el-button
          class="mr-2 ml-1"
          type="primary"
          plain
          size="small"
          @click="setCostRateVisible = true"
        >
          {{ $l('btn_setCostRate') || '变更费率' }}
        </el-button>
      </div>
      <div v-if="isAudit && formData.pdcostsOrderStatus === 'S'">
        <el-divider direction="vertical"></el-divider>
        <el-button
          class="ml-1"
          type="success"
          plain
          size="small"
          @click="review()"
        >
          {{ $l('INDEX.btn_reviewApproved') || '审核通过' }}
        </el-button>
        <el-button type="warning" plain size="small" @click="reject()">
          {{ $l('INDEX.Rejected') || '驳回' }}
        </el-button>
      </div>
    </div>

    <el-row :gutter="10">
      <el-col :lg="{ span: 24 }" :xl="{ span: 20 }">
        <el-descriptions border size="small" :column="6">
          <el-descriptions-item
            :label="$l('form_label_managementFeeRate') || '管理费率'"
            :labelStyle="{ width: '70px' }"
            :contentStyle="{ width: '60px' }"
          >
            {{ v_managementFeeRate }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_managementFee') || '订单管理费'"
            :labelStyle="{ width: '90px' }"
            :contentStyle="{ width: '110px' }"
          >
            {{ v_managementFee }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_profitRate') || '毛利率'"
            :labelStyle="{ width: '70px' }"
            :contentStyle="{ width: '60px' }"
          >
            {{ v_profitRate }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_profit') || '订单毛利'"
            :labelStyle="{ width: '80px' }"
            :contentStyle="{ width: '110px' }"
          >
            {{ v_profit }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_vatRate') || '增值税率'"
            :labelStyle="{ width: '70px' }"
            :contentStyle="{ width: '60px' }"
          >
            {{ v_vatRate }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_vat') || '增值税额'"
            :labelStyle="{ width: '80px' }"
            :contentStyle="{ width: '110px' }"
          >
            {{ v_vat }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions border size="small" :column="4" class="bottom-desc">
          <el-descriptions-item
            :label="$l('form_label_orderAmount') || '订单成本'"
            :labelStyle="{ width: '90px' }"
            :contentStyle="{ width: '200px' }"
          >
            {{ v_orderAmount }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_ftyCostAmount') || '核算成本'"
            :labelStyle="{ width: '90px' }"
            :contentStyle="{ width: '200px' }"
          >
            {{ v_ftyCostAmount }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_difference') || '差异金额'"
            :labelStyle="{ width: '90px' }"
            :contentStyle="{ width: '200px' }"
          >
            <span :class="differenceContentClassName">{{ v_difference }}</span>
            <span v-if="formData.difference != undefined">
              {{ formData.v_currencyUnit }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_differenceRate') || '差异率'"
            :labelStyle="{ width: '90px' }"
            :contentStyle="{ width: '200px' }"
            :contentClassName="differenceContentClassName"
          >
            {{ v_differenceRate }}
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>

    <OrderGoodsTable
      ref="orderGoodsTable"
      class="mt-2"
      :disabled="disabled"
      :pdCostsOrderCode="pdCostsOrderCode"
      @reload="getData"
    />

    <SetCostRateDialog
      :visible.sync="setCostRateVisible"
      :pdCostsOrderCode="formData.pdCostsOrderCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import OrderGoodsTable from '../order-goods'
import SetCostRateDialog from '../set-cost-rate'
import EditLoading from '@/mixins/edit-loading'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  components: { OrderGoodsTable, SetCostRateDialog },
  props: {
    pdCostsOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isAudit: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      setCostRateVisible: false,
    }
  },
  computed: {
    v_managementFeeRate() {
      const { managementFeeRate } = this.formData
      return undefined == managementFeeRate ? '' : `${managementFeeRate}%`
    },
    v_managementFee() {
      return format(this.formData.managementFee)
    },
    v_profitRate() {
      const { profitRate } = this.formData
      return undefined == profitRate ? '' : `${profitRate}%`
    },
    v_profit() {
      return format(this.formData.profit)
    },
    v_vatRate() {
      const { vatRate } = this.formData
      return undefined == vatRate ? '' : `${vatRate}%`
    },
    v_vat() {
      return format(this.formData.vat)
    },
    v_orderAmount() {
      const { orderAmount, v_currencyUnit } = this.formData
      return `${format(orderAmount)} ${v_currencyUnit || ''}`
    },
    v_ftyCostAmount() {
      const { ftyCostAmount, v_currencyUnit } = this.formData
      if (ftyCostAmount == undefined) return ''
      return `${format(ftyCostAmount)} ${v_currencyUnit || ''}`
    },
    v_difference() {
      const { difference } = this.formData
      if (difference == undefined) return ''
      if (difference == 0) return 0

      const v_difference = format(difference)
      return difference > 0 ? `+${v_difference}` : v_difference
    },
    v_differenceRate() {
      const { differenceRate } = this.formData
      if (differenceRate == undefined) return ''
      if (differenceRate == 0) return `${differenceRate}%`

      return differenceRate > 0 ? `+${differenceRate}%` : `${differenceRate}%`
    },
    differenceContentClassName() {
      const { differenceRate } = this.formData
      if (differenceRate == undefined || differenceRate == 0) return ''

      return differenceRate < 0 ? 'label-red' : 'label-green'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.pdCostsOrderCode) return
      const res = await this.$api
        .pdCostsOrderDetailApi({
          pdCostsOrderCode: this.pdCostsOrderCode,
        })
        .catch(() => null)
      if (!res || !res.body) return
      this.formData = res.body
    },
    reload() {
      this.getData()
      this.$refs.orderGoodsTable.getData()
    },
    review() {
      if (!this.pdCostsOrderCode) return
      this.$confirm(
        this.$l('INDEX.tips_question_review') || '是否审核通过？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .pdCostsOrderReviewApi({ pdCostsOrderCode: this.pdCostsOrderCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(
            this.$l('INDEX.tips_audit_failure') || '审核失败！'
          )
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_audit_success') || '审核成功！',
          type: 'success',
        })
        this.getData()
      })
    },
    reject() {
      if (!this.pdCostsOrderCode) return
      this.$confirm(
        this.$l('INDEX.tips_question_reject') || '是否驳回该审核请求？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .pdCostsOrderRejectApi({ pdCostsOrderCode: this.pdCostsOrderCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(
            this.$l('INDEX.tips_reject_failed') || '驳回失败！'
          )
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_rejected_successfully') || '驳回成功！',
          type: 'success',
        })
        this.getData()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 2px 10px;
  border-left: 3px solid $color-success;
  margin: 0;
}
::v-deep {
  .pdCostsOrder-detail-main-form {
    .form-label {
      width: 120px !important;
    }
  }

  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
    .label-red {
      color: red !important;
    }
    .label-green {
      color: green !important;
    }
  }
}
</style>
